import { PersonState } from './types'
import { AsyncStateStatus } from '../root.types'
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'

const initialState: PersonState = {
    request: {
        status: AsyncStateStatus.INITIAL,
        name: '',
        data: []
    },
    describe: {
        status: AsyncStateStatus.INITIAL,
        name: 'Carregando...',
        cpf: 'Carregando...',
        personDatas: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
        personContacts: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
        personAddress: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
        personWorks: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
        personAutos: {
            status: AsyncStateStatus.INITIAL,
            data: []
        }
    },
    address: {
        status: AsyncStateStatus.INITIAL,
        data: []
    }
}

export const personSlice = createSlice({
    name: '@person',
    initialState,
    reducers: {
        personRequest: (state: Draft<PersonState>) => {
            state.request.status = AsyncStateStatus.LOADING
        },
        personSuccess: (state: Draft<PersonState>, action: PayloadAction<{ data: any } >) => {
            state.request.status = AsyncStateStatus.SUCCESS
            state.request.data = action.payload.data
        },
        personFailure: (state: Draft<PersonState>) => {
            state.request.status = AsyncStateStatus.FAILURE
            state.request.data = []
        },
        personCancel: (state: Draft<PersonState>) => {
            state.request.status = AsyncStateStatus.INITIAL
            state.request.data = []
        },
        describeRequest: (state: Draft<PersonState>) => {
            state.describe.cpf = initialState.describe.cpf
            state.describe.name = initialState.describe.name
            state.describe.status = AsyncStateStatus.LOADING
            state.describe.personDatas.status = AsyncStateStatus.LOADING
            state.describe.personAddress.status = AsyncStateStatus.LOADING
            state.describe.personContacts.status = AsyncStateStatus.LOADING
            state.describe.personWorks.status = AsyncStateStatus.LOADING
            state.describe.personAutos.status = AsyncStateStatus.LOADING
            state.describe.personDatas.data = initialState.describe.personDatas.data
            state.describe.personAddress.data = initialState.describe.personAddress.data
            state.describe.personContacts.data = initialState.describe.personContacts.data
            state.describe.personWorks.data = initialState.describe.personWorks.data
            state.describe.personAutos.data = initialState.describe.personAutos.data
        },
        describeSuccess: (state: Draft<PersonState>, action: PayloadAction<{ data: any } >) => {
            state.describe.status = AsyncStateStatus.SUCCESS
            state.describe.name = action.payload.data.name
            state.describe.cpf = action.payload.data.cpf
            state.describe.personDatas.data = action.payload.data.personDatas
            state.describe.personContacts.data = action.payload.data.personContacts
            state.describe.personWorks.data = action.payload.data.personWorks
            state.describe.personAutos.data = action.payload.data.personAutos
            state.describe.personAddress.data = action.payload.data.personAddress
            state.describe.personDatas.status = AsyncStateStatus.SUCCESS
            state.describe.personAddress.status = AsyncStateStatus.SUCCESS
            state.describe.personContacts.status = AsyncStateStatus.SUCCESS
            state.describe.personWorks.status = AsyncStateStatus.SUCCESS
            state.describe.personAutos.status = AsyncStateStatus.SUCCESS
        },
        describeFailure: (state: Draft<PersonState>, action: PayloadAction<{ data: any } >) => {
            state.describe.status = AsyncStateStatus.FAILURE
            state.describe.personDatas.status = AsyncStateStatus.FAILURE
            state.describe.personContacts.status = AsyncStateStatus.FAILURE
            state.describe.personWorks.status = AsyncStateStatus.FAILURE
            state.describe.personAddress.status = AsyncStateStatus.FAILURE
            state.describe.personAutos.status = AsyncStateStatus.FAILURE
            state.describe.name = action.payload.data.name
            state.describe.cpf = action.payload.data.cpf
        },
        addressRequest: (state: Draft<PersonState>) => {
            state.address.status = AsyncStateStatus.LOADING
        },
        addressSuccess: (state: Draft<PersonState>, action: PayloadAction<{ data: any } >) => {
            state.address.status = AsyncStateStatus.SUCCESS
            state.address.data = action.payload.data
        },
        addressFailure: (state: Draft<PersonState>) => {
            state.address.status = AsyncStateStatus.FAILURE
        },
    }
})

/**
 * <h5>Functions that trigger actions related to authentication in the system.</h5>
 * @see {@link https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#designing-actions}
 * @typedef PersonActions
 * @namespace PersonActions
 * @category React
 * @subcategory Redux / Actions
 * @property {Function} personRequest
 * @property {Function} personSuccess
 * @property {Function} personFailure
 * @property {Function} describeRequest
 * @property {Function} describeSuccess
 * @property {Function} describeFailure
 */
export const PersonActions = personSlice.actions

export default personSlice.reducer
